<template>
	<ViewWrapper :carregando="loading">
		<template #titulo>
			{{ rotaAdmin ? "Solicitações de Vagas" : "Acompanhar Vagas" }}
		</template>
		<template #botaoHeader>
			<v-row justify="center">
				<v-col cols="6" class="align-content-center">
						<v-btn
							block
							:color="corTexto"
							variant="outlined"
							text="LIMPAR"
							@click="limparFiltros"
						></v-btn>
				</v-col>
				<v-col cols="6" class="align-content-center">
						<v-btn
							block
							color="primary"
							text="PESQUISAR"
							@click="consultaListagemVagas()"
						></v-btn>
				</v-col>
			</v-row>
		</template>
		<v-container fluid>
			<v-row>
				<v-col cols="12" md="4">
					<div class="mb-2 mr-6 text-hidden">Protocolo</div>
					<v-combobox v-model="filtros.protocolo" />
				</v-col>
				<v-col cols="12" md="4">
					<div class="mb-2 mr-6 text-hidden">CNPJ/CAEPF/CPF</div>
					<v-combobox v-model="filtros.numeroIdentificacaoEmpregador" />
				</v-col>
				<v-col cols="12" md="4">
					<div class="mb-2 mr-6 text-hidden">Situação</div>
					<v-combobox v-model="filtros.situacao" multiple :items="listaSituacao.filter((s) => !s.disabled)" item-title="label" item-value="value" />
				</v-col>
				<v-col cols="12" md="4">
					<div class="mb-2 mr-6 text-hidden">Ocupação</div>
					<v-combobox v-model="filtros.ocupacao" :items="listaCBO" item-title="label" item-value="id" />
				</v-col>
				<v-col cols="12" md="4">
					<div class="mb-2 mr-6 text-hidden">Agência</div>
					<v-combobox v-model="filtros.idAgencia" :items="listaAgencias" item-title="nome" item-value="id" />
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12">
					<v-data-table
						:loading="loading"
						:page="pagination.currentPage"
						:items-per-page="pagination.perPage"
						:headers="headers"
						:server-items-length="pagination.totalRows"
						:items="listaVagas"
						no-data-text="Nenhum dado encontrado!"
						loading-text="Carregando..."
						:footer-props="{
							itemsPerPageText: 'Itens por página: ',
							disableItemsPerPage:true,
							disablePagination:true,
						}"
						hide-default-footer
						>
						<template v-slot:item.situacao="{ item }">
							<span :class="`text-${listaSituacao.find((s) => s.value === item.situacao).textColor}`">{{ listaSituacao.find((s) => s.value === item.situacao).label }}</span>
						</template>
						<template v-slot:header.dataInicio="{ column }">
							<v-btn
								variant="text"
								size="sm"
								:append-icon="isDesc ? 'mdi-arrow-down' : 'mdi-arrow-up'"
								@click="sortTabela"
								>
									{{ column.title }}
							</v-btn>
						</template>
						<template v-slot:item.acoes="{ item }">
							<v-btn
								v-if="rotaAdmin"
								block
								color="primary"
								:text="(item.situacao === 'PROTOCOLADA' && usuarioPossuiPermissao(usuarioLogado, PERMISSOES_FGTAS.ANALISAR_VAGA)) ? 'ANALISAR' : 'VISUALIZAR'"
								@click="handleAnalisar(item)"
							></v-btn>
							<v-menu v-else offset-y>
								<template v-slot:activator="{ props }">
									<v-btn
										variant="outlined"
										color="gray600"
										border="none"
										icon="mdi-dots-horizontal"
										v-bind="props"
										/>
								</template>
								<v-list dense>
									<v-list-item
									 	v-if="permissaoAcao.visualizar.includes(item.situacao) && usuarioPossuiPermissao(usuarioLogado, PERMISSOES_FGTAS.ACOMPANHAR_VAGA)"
										:to="`/vagas/${item.id}/visualizar`"
										link
										density="compact"
										prepend-icon="mdi-eye-outline"
										color="black"
										title="Visualizar"
										/>
									<v-list-item
									 	v-if="permissaoAcao.editar.includes(item.situacao) && usuarioPossuiPermissao(usuarioLogado, PERMISSOES_FGTAS.CADASTRAR_VAGA)"
										:to="`/vagas/${item.id}/editar`"
										link
										density="compact"
										prepend-icon="mdi-pencil-outline"
										color="black"
										title="Editar"
										/>
									<v-list-item
									 	v-if="permissaoAcao.cancelar.includes(item.situacao) && usuarioPossuiPermissao(usuarioLogado, PERMISSOES_FGTAS.CANCELAR_VAGA)"
										density="compact"
										prepend-icon="mdi-close"
										color="black"
										title="Cancelar Vaga"
										@click="{
											exibeModal = true;
											vagaSelecionada = item;
										}"
										/>
									<v-list-item
									 	v-if="permissaoAcao.cadastrar.includes(item.situacao) && usuarioPossuiPermissao(usuarioLogado, PERMISSOES_FGTAS.CADASTRAR_VAGA)"
										:to="`/vagas/${item.id}`"
										link
										density="compact"
										prepend-icon="mdi-pencil-outline"
										color="black"
										title="Cadastrar"
										/>
									<v-list-item
									 	v-if="permissaoAcao.excluir.includes(item.situacao) && usuarioPossuiPermissao(usuarioLogado, PERMISSOES_FGTAS.CADASTRAR_VAGA)"
										link
										density="compact"
										prepend-icon="mdi-close"
										color="black"
										title="Excluir"
										@click="{
											exibeModalExcluir = true;
											vagaSelecionada = item;
										}"
										/>
									<v-list-item
									 	v-if="permissaoAcao.reaproveitar.includes(item.situacao) && usuarioPossuiPermissao(usuarioLogado, PERMISSOES_FGTAS.CADASTRAR_VAGA)"
										link
										density="compact"
										prepend-icon="mdi-restart"
										color="black"
										title="Reaproveitar"
										@click="{
											exibeModalReaproveitar = true;
											vagaSelecionada = item;
										}"
										/>
								</v-list>
							</v-menu>
						</template>
					</v-data-table>
					<v-container class="mt-0 pa-0">
						<v-row class="pa-0">
							<v-col class="ml-2 d-flex align-center">
								<span class="mr-5 mt-3 fs-15">{{ textoPaginacao }}</span>
							</v-col>
							<v-col class="d-flex justify-end">
								<v-pagination
									:disabled="loading"
									total-visible=7
									:model-value="pagination.currentPage"
									@update:model-value="(event) => pagination.currentPage = event"
									:length="pagination.totalPages"
									/>
							</v-col>
						</v-row>
					</v-container>
				</v-col>
			</v-row>
		</v-container>
		<v-dialog v-model="exibeModalReaproveitar" width="auto" persistent>
			<v-card
				color="background"
				class="pa-4"
				max-width="500"
				style="border-radius: 10px;"
			>
				<template v-slot:title><span :class="`text-${corTexto}`">Deseja Reaproveitar essa vaga?</span></template>
				<template v-slot:append>
					<v-btn
						class="text-none"
						:color="corTexto"
						variant="text"
						slim
						icon="mdi-close"
						@click="{
							vagaSelecionada.value = undefined;
							exibeModalReaproveitar = false;
						}"
					></v-btn>
				</template>
				<div class="px-4">
					Ao prosseguir, uma nova vaga será gerada em rascunho, reaproveitando os dados inseridos na vaga selecionada.
				</div>
				<v-row class="mt-4 mb-2 px-12">
					<v-col cols="6" class="text-center">
						<v-btn
							block
							:color="corTexto"
							variant="outlined"
							text="CANCELAR"
							@click="{
								vagaSelecionada.value = undefined;
								exibeModalReaproveitar = false;
							}"
						></v-btn>
					</v-col>
					<v-col cols="6" class="text-center">
						<v-btn
							block
							color="primary"
							text="REAPROVEITAR"
							@click="reaproveitar"
						></v-btn>
					</v-col>
				</v-row>
			</v-card>
		</v-dialog>
		<v-dialog v-model="exibeModalExcluir" width="auto" persistent>
			<v-card
				color="background"
				class="pa-4"
				max-width="500"
				style="border-radius: 10px;"
			>
				<template v-slot:title><span :class="`text-${corTexto}`">Deseja excluir essa vaga?</span></template>
				<template v-slot:append>
					<v-btn
						class="text-none"
						:color="corTexto"
						variant="text"
						slim
						icon="mdi-close"
						@click="{
							vagaSelecionada.value = undefined;
							exibeModalExcluir = false;
						}"
					></v-btn>
				</template>
				<div class="px-4">
					Ao prosseguir, a vaga será excluida de forma definitiva, e não poderá ser recuperada.
				</div>
				<v-row class="mt-4 mb-2 px-12">
					<v-col cols="6" class="text-center">
						<v-btn
							block
							:color="corTexto"
							variant="outlined"
							text="VOLTAR"
							@click="{
								vagaSelecionada.value = undefined;
								exibeModalExcluir = false;
							}"
						></v-btn>
					</v-col>
					<v-col cols="6" class="text-center">
						<v-btn
							block
							color="danger"
							text="EXCLUIR VAGA"
							@click="excluir"
						></v-btn>
					</v-col>
				</v-row>
			</v-card>
		</v-dialog>
		<v-dialog v-model="exibeModal" width="auto" persistent>
			<v-card
				color="background"
				class="pa-4"
				max-width="500"
				style="border-radius: 10px;"
			>
				<template v-slot:title><span :class="`text-${corTexto}`">Deseja cancelar essa vaga?</span></template>
				<template v-slot:append>
					<v-btn
						class="text-none"
						:color="corTexto"
						variant="text"
						slim
						icon="mdi-close"
						@click="{
							vagaSelecionada.value = undefined;
							exibeModal = false;
							}"
					></v-btn>
				</template>
				<div class="px-4">
					Ao prosseguir, a solicitação de cadastro desta vaga será cancelada de forma definitiva, caso ainda esteja pendente de aprovação.
					<p class="mt-4">Para continuar, descreva e o motivo do cancelamento:</p>
					<div class="mt-2 mr-6"><b>Descreva o motivo do cancelamento</b></div>
					<v-text-field v-model="motivoCancelamento" hint="Ex.: Desistência" persistent-hint />
				</div>
				<v-row class="mt-4 mb-2 px-12">
					<v-col cols="6" class="text-center">
						<v-btn
							block
							:color="corTexto"
							variant="outlined"
							text="VOLTAR"
							@click="{
								vagaSelecionada.value = undefined;
								exibeModal = false;
								}"
						></v-btn>
					</v-col>
					<v-col cols="6" class="text-center">
						<v-btn
							block
							color="primary"
							text="CANCELAR VAGA"
							@click="cancelar"
						></v-btn>
					</v-col>
				</v-row>
			</v-card>
		</v-dialog>
	</ViewWrapper>
</template>
<script setup>
import { ref, onMounted, watch, computed } from 'vue';
import ViewWrapper from '@/components/commons/wrapper/ViewWrapper.vue';
import { analisarVaga, consultarVagas, excluirVaga, reaproveitarVaga } from '@/services/VagaService';
import { ErroAlert, SucessoAlert } from "@/utils/AlertUtils.js";
import { vuetify } from '@/plugins/vuetify'
import { cancelarVaga } from '@/services/VagaService';
import { useRoute, useRouter } from 'vue-router';
import { listarCBO } from '@/services/ConsultaEntidadeService';
import { useStore } from 'vuex';
import { PERMISSOES_FGTAS, usuarioPossuiPermissao } from '@/utils/PermissaoUtils';
import { manterApenasLetrasENumeros } from '@/utils/StringUtils';
import { buscarAgencias } from '@/services/AgenciaService';

const route = useRoute();
const router = useRouter();
const store = useStore();

const headers = [
	{ key: "protocolo", title: "PROTOCOLO", sortable: false },
	{ key: "razaoSocial", title: "RAZÃO SOCIAL/NOME COMPLETO", sortable: false, class: "text-uppercase" },
	{ key: "numeroIdentificacao", title: "CNPJ/CAEPF/CPF", sortable: false },
	{ key: "ocupacao", title: "OCUPAÇÃO", sortable: false },
	{ key: "situacao", title: "SITUAÇÃO", sortable: false, align: "center" },
	{ key: "dataInicio", title: "DATA INÍCIO", sortable: false, align: "center" },
	{ key: "acoes", title: "AÇÕES", sortable: false, align: "center" },
];

const permissaoAcao = {
	editar: ["PROTOCOLADA", "PENDENTE"],
	visualizar: ["PROTOCOLADA", "EM_ANALISE", "PENDENTE", "RETORNO_PENDENCIA", "CADASTRADA", "INDEFERIDA", "CANCELADA", "ENCERRADA"],
	cadastrar: ["RASCUNHO"],
	excluir: ["RASCUNHO"],
	cancelar: ["PROTOCOLADA", "PENDENTE"],
	reaproveitar: ["ENCERRADA"],
};

const loading = ref(false);
const rotaAdmin = ref(false);
const exibeModal = ref(false);
const exibeModalExcluir = ref(false);
const exibeModalReaproveitar = ref(false);
const listaVagas = ref([]);
const listaAgencias = ref([]);
const listaCBO = ref([]);
const vagaSelecionada = ref();
const motivoCancelamento = ref();
const isDesc = ref(true);
const filtros = ref({
	protocolo: undefined,
	numeroIdentificacaoEmpregador: undefined,
	situacao: undefined,
	ocupacao: undefined,
	idAgencia: undefined,
	sort: "dataInicio,desc"
});
const pagination = ref({
	page: 0,
	size: 10,
	perPage: 10,
	currentPage: 1,
	totalRows: 0,
	totalPages: 0,
});

const usuarioLogado = computed(() => store.getters["usuario/getUsuarioLogado"]);

const listaSituacao = computed(() => {
	return [
	{ label: "RASCUNHO", value: "RASCUNHO", textColor: "situacaoRascunho", disabled: rotaAdmin.value, },
	{ label: "PROTOCOLADA", value: "PROTOCOLADA", textColor: "situacaoProtocolada" },
	{ label: "EM ANÁLISE", value: "EM_ANALISE", textColor: "situacaoEmAnalise" },
	{ label: "PENDENTE", value: "PENDENTE", textColor: "situacaoPendente" },
	{ label: "EM ANÁLISE (RETORNO DE PENDÊNCIA)", value: "RETORNO_PENDENCIA", textColor: "situacaoRetornoPendencia" },
	{ label: "VAGA CADASTRADA", value: "CADASTRADA", textColor: "situacaoCadastrada" },
	{ label: "INDEFERIDA", value: "INDEFERIDA", textColor: "situacaoIndeferida" },
	{ label: "CANCELADA", value: "CANCELADA", textColor: "situacaoCancelada" },
	{ label: "ENCERRADA", value: "ENCERRADA", textColor: "situacaoEncerrada" },
]});

const corTexto = computed(() => {
	return vuetify.theme.current.value.dark ? "white" : "primary";
});

const textoPaginacao = computed(() => {
	if(pagination.value.totalRows){
		if(pagination.value.totalRows === 0){
			return "Nenhum registro localizado";
		}
		if(pagination.value.totalRows === 1){
			return "1 registro recuperado";
		}
		return `${pagination.value.totalRows} registros recuperados`;
	}
	return "";
});

async function consultaListagemVagas(page) {
	pagination.value.currentPage = page ? pagination.value.currentPage : 1;
	pagination.value.page = page ? pagination.value.currentPage - 1 : 0;
	loading.value = true;
	await consultarVagas({
		page: pagination.value.page,
		size: pagination.value.size,
		perPage: pagination.value.perPage,
		currentPage: pagination.value.currentPage,
		sort: filtros.value.sort ? filtros.value.sort : undefined,
	}, {
		situacoes: (filtros.value.situacao && filtros.value.situacao.length) ? filtros.value.situacao.map((x) => x.value).join(",") : undefined,
		ocupacao: filtros.value.ocupacao ? filtros.value.ocupacao.descricao : undefined,
		protocolo: filtros.value.protocolo ? filtros.value.protocolo : undefined,
		numeroIdentificacaoEmpregador: filtros.value.numeroIdentificacaoEmpregador ? manterApenasLetrasENumeros(filtros.value.numeroIdentificacaoEmpregador).toUpperCase() : undefined,
		idAgencia: filtros.value.idAgencia ? filtros.value.idAgencia.id : undefined,
		registroAtivo: true,
		usuarioSolicitante: !rotaAdmin.value ? true : undefined,
		usuarioAnalista: rotaAdmin.value ? true : undefined,
	})
		.then(({ data }) => {
			pagination.value.size = data.size;
			pagination.value.totalPages = data.totalPages;
			listaVagas.value = data.content;
			pagination.value.totalRows = data.totalElements;
		})
		.catch((error) => {
			ErroAlert({ mensagem: "Não foi possível lista as vagas no momento. Tente novamente mais tarde!", error });
		})
		.finally(() => loading.value = false);
}

async function limparFiltros() {
	isDesc.value = true;
	filtros.value.situacao = undefined;
	filtros.value.ocupacao = undefined;
	filtros.value.protocolo = undefined;
	filtros.value.numeroIdentificacaoEmpregador = undefined;
	filtros.value.idAgencia = undefined;
	filtros.value.sort = "dataInicio,desc"
	await consultaListagemVagas();
}

async function reaproveitar() {
	loading.value = true;
	await reaproveitarVaga(vagaSelecionada.value.id)
		.then(async ({ data }) => {
			SucessoAlert({ mensagem: "Vaga reaproveitada com sucesso!" });
			router.push(`/vagas/${data.id || 0}`);
			vagaSelecionada.value = undefined;
			exibeModalReaproveitar.value = false;
		})
		.catch((error) => {
			ErroAlert({ mensagem: "Não foi possível reaproveitar a vaga no momento. Tente novamente mais tarde", error });
		})
		.finally(() => loading.value = false);
}

async function excluir() {
	loading.value = true;
	await excluirVaga(vagaSelecionada.value.id)
		.then(async () => {
			SucessoAlert({ mensagem: "Vaga excluida com sucesso!" });
			await consultaListagemVagas();
			vagaSelecionada.value = undefined;
			exibeModalExcluir.value = false;
		})
		.catch((error) => {
			ErroAlert({ mensagem: "Não foi possível excluir a vaga no momento. Tente novamente mais tarde", error });
		})
		.finally(() => loading.value = false);
}

async function handleAnalisar(vaga) {
	if (vaga.situacao === listaSituacao.value[1].value && usuarioPossuiPermissao(usuarioLogado.value, PERMISSOES_FGTAS.ANALISAR_VAGA)) {
		loading.value = true;
		await analisarVaga(vaga.id || 0)
			.then(({ data }) => {
				router.push(`/admin/vagas/${vaga.id}`);
			})
			.catch((error) => {
				ErroAlert({ mensagem: "Não foi possível iniciar analise da vaga no momento. Tente novamente mais tarde!", error });
			})
			.finally(() => loading.value = false);
	}
	else {
		router.push(`/admin/vagas/${vaga.id}`);
	}
}

async function cancelar() {
	loading.value = true;
	await cancelarVaga(vagaSelecionada.value.id, { motivo: motivoCancelamento.value || undefined })
		.then(async () => {
			SucessoAlert({ mensagem: "Vaga cancelada com sucesso!" });
			await consultaListagemVagas();
			vagaSelecionada.value = undefined;
			motivoCancelamento.value = undefined;
			exibeModal.value = false;
		})
		.catch((error) => {
			ErroAlert({ mensagem: "Não foi possível cancelar a vaga no momento. Tente novamente mais tarde", error });
		})
		.finally(() => loading.value = false);
}

async function buscarCBO() {
	if (store.getters["entidades/getListaCBO"].length) {
		listaCBO.value = store.getters["entidades/getListaCBO"];
		if (filtros.value.ocupacao) {
			filtros.value.ocupacao = listaCBO.value.find((cbo) => cbo.descricao === filtros.value.ocupacao)
		}
		return;
	}
	await listarCBO()
		.then(({ data }) => {
			listaCBO.value = data.map((item) => {
				return {
					id: item.id,
					codigo: item.codigo,
					descricao: item.descricao,
					label: `${item.codigo} | ${item.descricao}`
				}
			});
			store.commit("entidades/setListaCBO", listaCBO.value)
		})
		.catch((error) => {
			console.error(error.response.data.mensagem)
		});
}

async function buscaAgencias() {
	if (store.getters["entidades/getListaAgencias"].length) {
		listaAgencias.value = store.getters["entidades/getListaAgencias"];
		return;
	}
	await buscarAgencias()
		.then(({ data }) => {
			listaAgencias.value = data;
			store.commit("entidades/setListaAgencias", data)
		})
		.catch((error) => {
			console.error(error.response.data.mensagem)
		});
}

async function sortTabela() {
	if (isDesc.value) {
		filtros.value.sort = "dataInicio,asc"
		isDesc.value = false
	} else {
		filtros.value.sort = "dataInicio,desc"
		isDesc.value = true
	}

	await consultaListagemVagas();
}

watch(() => pagination.value.currentPage, async (newValue, oldValue) => {
	if (newValue !== oldValue) {
		await consultaListagemVagas(newValue);
	}
}, { deep: true });

onMounted(async () => {
	if (route.fullPath.includes("/admin")) {
		rotaAdmin.value = true;
		filtros.value.situacao = [listaSituacao.value[1], listaSituacao.value[2], listaSituacao.value[4]];
	}
	const temPermissao = usuarioPossuiPermissao(usuarioLogado.value, rotaAdmin.value ? PERMISSOES_FGTAS.VISUALIZAR_SOLICITACAO_VAGA : PERMISSOES_FGTAS.ACOMPANHAR_VAGA);
	if (!temPermissao) {
		console.warn("Você não possui permissão para acessar esta tela!");
		router.push("/");
	}
	await buscarCBO();
	await buscaAgencias();
	await consultaListagemVagas();
});
</script>
